(() => {
  'use strict';
  if (window.MayLondonDelivery) return;
  window.MayLondonDelivery = true;
  function init(scope) {
    scope.querySelectorAll('[data-delivery-estimate]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const form = root.querySelector('form'), button = form.querySelector('button');
      const status = root.querySelector('[data-delivery-status]'), table = root.querySelector('table');
      const base = root.dataset.root.replace(/\/$/, '') + '/';
      let active = null;
      function clear() {
        active?.abort(); active = null;
        table.hidden = true; table.querySelector('tbody').replaceChildren();
        status.textContent = ''; button.disabled = false; root.removeAttribute('aria-busy');
      }
      form.addEventListener('input', clear);
      form.addEventListener('change', clear);
      document.addEventListener('cart:updated', clear);
      window.addEventListener('pagehide', clear);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) clear(); });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (active || !form.reportValidity()) return;
        clear();
        const controller = new AbortController(); active = controller;
        const timeout = setTimeout(() => controller.abort(), 20000);
        button.disabled = true; root.setAttribute('aria-busy', 'true'); status.textContent = root.dataset.loading;
        const read = async (url, method = 'GET') => {
          const response = await fetch(url, { method, credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Shipping request failed');
          return response.json();
        };
        try {
          const cart = await read(base + 'cart.js');
          if (!cart.item_count) { status.textContent = root.dataset.empty; return; }
          const params = new URLSearchParams();
          for (const field of ['country', 'zip', 'province']) params.set(`shipping_address[${field}]`, form.elements[field].value.trim());
          const query = '?' + params.toString();
          await read(base + 'cart/prepare_shipping_rates.json' + query, 'POST');
          let result = null;
          for (let attempt = 0; attempt < 10; attempt++) {
            result = await read(base + 'cart/async_shipping_rates.json' + query);
            if (result !== null) break;
            await new Promise(resolve => setTimeout(resolve, 1000));
            if (controller.signal.aborted) throw new Error('Cancelled');
          }
          if (active !== controller) return;
          if (!Array.isArray(result?.shipping_rates)) throw new Error('Shipping rates not ready');
          const rows = result.shipping_rates.filter(rate => (rate.presentment_name || rate.name) && rate.price != null && Number.isFinite(Number(rate.price)) && Number(rate.price) >= 0);
          for (const rate of rows) {
            const row = document.createElement('tr'), name = document.createElement('td'), price = document.createElement('td');
            name.textContent = rate.presentment_name || rate.name;
            if (rate.description) { const detail = document.createElement('small'); detail.textContent = rate.description; name.append(detail); }
            price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: rate.currency || cart.currency }).format(Number(rate.price));
            row.append(name, price); table.querySelector('tbody').append(row);
          }
          table.hidden = rows.length === 0;
          status.textContent = rows.length ? '' : root.dataset.none;
        } catch (_) {
          if (active === controller) { table.hidden = true; status.textContent = root.dataset.error; }
        } finally {
          clearTimeout(timeout);
          if (active === controller) { active = null; button.disabled = false; root.removeAttribute('aria-busy'); }
        }
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
